/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { EmailLoginDto, EmailSignUpDto, PasswordResetDto, TokenDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AuthService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AuthService
   * @name SignUpWithEmail
   * @summary Email Sign Up
   * @request POST:/v1/auth/signup
   * @secure
   */
  signUpWithEmail = (data: EmailSignUpDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/auth/signup`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AuthService
   * @name RefreshToken
   * @summary Refresh Token
   * @request POST:/v1/auth/refresh-token
   * @secure
   */
  refreshToken = (data: TokenDto, params: RequestParams = {}) =>
    this.http.request<TokenDto, any>({
      path: `/v1/auth/refresh-token`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AuthService
   * @name TestLogin
   * @summary Test Login
   * @request POST:/v1/auth/login/test-login
   * @secure
   */
  testLogin = (data: EmailLoginDto, params: RequestParams = {}) =>
    this.http.request<TokenDto, any>({
      path: `/v1/auth/login/test-login`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AuthService
   * @name LoginWithEmail
   * @summary Email Login
   * @request POST:/v1/auth/login/email
   * @secure
   */
  loginWithEmail = (data: EmailLoginDto, params: RequestParams = {}) =>
    this.http.request<TokenDto, any>({
      path: `/v1/auth/login/email`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AuthService
   * @name ChangePassword
   * @summary Reset Password
   * @request POST:/v1/auth/change-password
   * @secure
   */
  changePassword = (data: PasswordResetDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/auth/change-password`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
